import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import runtimeConfig from './runtimeConfig';
import { envUrl } from '../app/services/environment/EnvironmentService';
import ProductsPage from '../app/products/ProductsPageContainer';
import ProductList from '../app/products/list/ProductsListContainer';
import { getUrlPathByProductRoute, isValidProductTypeRoute } from '../app/services/products-route/ProductsRouteService';

const MainProducts = (props) => (
  <ProductsPage {...props}>
    <ProductList runtimeConfig={runtimeConfig} match={props.match} />
  </ProductsPage>
);

const componentMap = {
  MainProducts,
};

/**
 * if it is a normal product route i.e. business-cards renders the prod list as expected
 * else gets the route correspondent to the id/size provided (needed by the redirects from pixel)
 * redirect also handles fallback case(not a known route => redirect to business-cards)
 * */
const ProductsRoutes = ({ componentMapOverride }) => {
  const pages = componentMapOverride ? componentMapOverride(componentMap) : componentMap;

  return (
    <Switch>
      <Route exact path={envUrl('/products')}>
        <Redirect to={envUrl('/products/all')} />
      </Route>
      <Route
        exact
        key="product-type-route"
        path={envUrl('/products/:type')}
        render={(props) => {
          const { type } = props.match.params;
          return isValidProductTypeRoute(type) ? (
            <pages.MainProducts {...props} />
          ) : (
            <Redirect to={envUrl(getUrlPathByProductRoute(type))} />
          );
        }}
      />
    </Switch>
  );
};

export default ProductsRoutes;
